"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerHeader = DrawerHeader;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _paddingLevel = require("../../common/paddingLevel");
var _thumbtackClasses = require("../../common/thumbtackClasses");
var _IconButton = require("../button/IconButton");
var _iconNames = require("../icon/iconNames");
var _typography = require("../typography/typography");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DrawerHeader(_ref) {
  var handleClose = _ref.handleClose,
    paddingLevel = _ref.paddingLevel,
    children = _ref.children,
    text = _ref.text;
  /**
   * The title will most likely be a string for normal drawers, but may be an element for inline drawers
   * We need the wrapping div for complex content as it forms the left hand item in our flexbox
   */
  var isTextContent = text !== undefined;
  var contentElement = isTextContent ? /*#__PURE__*/React.createElement(_typography.Heading2, {
    title: text
  }, text) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
  var classes = (0, _classnames.default)(_classes.Classes.DRAWER_HEADER, (0, _thumbtackClasses.paddingLevelClass)(paddingLevel || _paddingLevel.PaddingLevel.REGULAR));

  /**
   * The reason we're not using a Frow to do the flexbox is because I don't want to touch the existing
   * drawer-header styles. The title element is allowed to grow in case we need to place items on the right
   * hand side next to the close button
   */
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, contentElement, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '24px'
    }
  }, /*#__PURE__*/React.createElement(_IconButton.IconButton40, {
    className: _classes.Classes.DRAWER_CLOSE_BUTTON,
    icon: _iconNames.IconNames16.CROSS_CIRCLE,
    onClick: handleClose,
    "aria-label": "Close"
  })));
}